<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <ng-template #title>
      <h1>
        {{ 'label.inspections' | translate }}
      </h1>
    </ng-template>
    <div class="flex items-center justify-end gap-2 mb-5">
      @if (modelFilter(); as filter) {
        <div class="mr-auto flex items-center gap-2">
          <p-tag
            severity="info"
            icon="fa fa-filter"
            [value]="
              ('inspection.filteredFor' | translate) + ': ' + filter.name
            "
          />
          <p-button
            (click)="clearModelFilter()"
            [label]="'inspection.showAll' | translate"
            severity="secondary"
            text
          />
        </div>
      }
      <p-button
        (click)="onRowCreateInit()"
        [label]="'inspection.add' | translate"
      />
    </div>

    <p-table
      #inspectionsTable
      [value]="displayInspections()"
      stripedRows
      showGridlines
      dataKey="id"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="date"
      [sortOrder]="-1"
      [scrollable]="true"
      [loading]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      editMode="row"
      [globalFilterFields]="globalFilterFields"
    >
      <ng-template #header>
        <tr>
          <th></th>
          @for (column of inspectionColumns; track $index) {
            <th rowspan="2" [pSortableColumn]="column.field" pResizableColumn>
              {{ column.header | translate }}
              @if (column.sortField) {
                <p-sortIcon [field]="column.sortField" />
              }
              @if (column.filterField) {
                @if (column.matchMode === 'between') {
                  <p-columnFilter
                    [field]="column.filterField"
                    matchMode="between"
                    display="menu"
                    [showOperator]="false"
                    [showMatchModes]="false"
                    [showAddButton]="false"
                  >
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-datepicker
                        [ngModel]="value"
                        (ngModelChange)="filter($event)"
                        selectionMode="range"
                        dateFormat="dd.mm.yy"
                        [readonlyInput]="true"
                        appendTo="body"
                      />
                    </ng-template>
                  </p-columnFilter>
                } @else {
                  <p-columnFilter
                    [field]="column.filterField"
                    display="menu"
                    [type]="column.type"
                    [matchMode]="column.matchMode"
                    [showOperator]="column.showOperator || false"
                    [showMatchModes]="column.showMatchModes || false"
                    [showAddButton]="column.showAddButton || false"
                  ></p-columnFilter>
                }
              }
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-inspection
        let-expanded="expanded"
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="inspection">
          <td>
            <p-button
              type="button"
              pRipple
              [pRowToggler]="inspection"
              [text]="true"
              severity="secondary"
              [rounded]="true"
              [icon]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"
            />
          </td>
          @for (column of inspectionColumns; track $index) {
            @switch (column.displayType) {
              @case ('text') {
                <td>
                  <p-cellEditor>
                    <ng-template #input>
                      <input
                        pInputText
                        type="text"
                        [(ngModel)]="inspection[column.field]"
                        [ngClass]="{
                          'ng-invalid ng-dirty': invalidFieldsMap()
                            .get(inspection.id)
                            ?.has(column.field),
                        }"
                      />
                    </ng-template>
                    <ng-template #output>
                      {{ inspection[column.field] }}
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              @case ('tags') {
                <td>
                  <p-cellEditor>
                    <ng-template #input>
                      <p-multiselect
                        [options]="column.textOptions || []"
                        [(ngModel)]="inspection[column.field]"
                        [placeholder]="
                          column.placeholder
                            ? (column.placeholder | translate)
                            : undefined
                        "
                        display="chip"
                        class="w-full md:w-80"
                        appendTo="body"
                      />
                    </ng-template>
                    <ng-template #output>
                      <div class="w-full md:w-80 flex">
                        @for (tag of inspection[column.field]; track $index) {
                          <p-tag
                            [value]="tag.toLowerCase()"
                            severity="success"
                            styleClass="m-1"
                          />
                        }
                      </div>
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              @case ('boolean') {
                <td class="text-center">
                  <p-cellEditor>
                    <ng-template #input>
                      <p-toggleswitch [(ngModel)]="inspection[column.field]" />
                    </ng-template>
                    <ng-template #output>
                      <i
                        class="text-2xl fa"
                        [ngClass]="{
                          'text-lime-500 fa-check-circle':
                            inspection[column.field],
                          'text-red-500 fa-times-circle':
                            !inspection[column.field],
                        }"
                      ></i>
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              @case ('date') {
                <td>
                  <p-cellEditor>
                    <ng-template #input>
                      <p-datepicker
                        [(ngModel)]="inspection[column.field]"
                        [showIcon]="true"
                        dateFormat="dd.mm.yy"
                        class="w-full"
                        appendTo="body"
                        [ngClass]="{
                          'ng-invalid ng-dirty': invalidFieldsMap()
                            .get(inspection.id)
                            ?.has(column.field),
                        }"
                      />
                    </ng-template>
                    <ng-template #output>
                      {{
                        inspection[column.field]
                          | date: 'dd.MM.yyyy' : 'Europe/Berlin'
                      }}
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              @case ('progress') {
                <td>
                  <p-progressbar
                    [value]="round(inspection[column.field] * 100)"
                  />
                </td>
              }
              @case (null) {
                {{ inspection[column.field] }}
              }
            }
          }
          <td>
            <div class="flex items-center justify-start gap-2">
              @if (editing) {
                <button
                  pButton
                  type="button"
                  icon="fa fa-floppy-disk"
                  (click)="onRowEditSave(inspection)"
                  text
                  rounded
                  severity="success"
                ></button>
                <button
                  pButton
                  type="button"
                  pCancelEditableRow
                  icon="fa fa-times"
                  (click)="onRowEditCancel(inspection)"
                  text
                  rounded
                  severity="danger"
                ></button>
              } @else {
                <button
                  pButton
                  type="button"
                  icon="fa fa-grid-2-plus"
                  (click)="manageModels(inspection)"
                  text
                  rounded
                  severity="secondary"
                ></button>
                <button
                  pButton
                  type="button"
                  pInitEditableRow
                  icon="fa fa-pencil"
                  (click)="onRowEditInit(inspection)"
                  text
                  rounded
                  severity="secondary"
                ></button>
                @if (inspection.status !== 1) {
                  <button
                    pButton
                    type="button"
                    icon="fa fa-trash"
                    (click)="onRowDeleteInit($event, inspection)"
                    text
                    rounded
                    severity="secondary"
                  ></button>
                }
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #expandedrow let-inspection>
        <tr>
          <td colspan="5" class="p-10">
            <app-inspection-item-table
              [inspection]="inspection"
              [(selectedInspection)]="selectedInspection"
              [(popupVisible)]="popupVisible"
              (itemChecked)="onItemChecked()"
            ></app-inspection-item-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-confirmdialog />
  </p-card>
</div>

<p-dialog
  [header]="
    ('label.manageInspectionItem' | translate) +
    ' - ' +
    selectedInspection()?.name
  "
  [modal]="true"
  [(visible)]="popupVisible"
  styleClass="w-[90vw] max-w-4xl"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-4 mb-4 w-full">
        <p-selectbutton
          inputId="itemType"
          [options]="itemTypeOptions"
          optionLabel="value"
          optionValue="key"
          formControlName="itemType"
          styleClass="w-full"
          (onChange)="changeItemOptions()"
        />
      </div>
      <div class="flex flex-col gap-4 mb-4 w-full">
        <label for="items">{{ 'label.InspectionItems' | translate }}</label>
        <p-multiselect
          inputId="items"
          [options]="itemOptions()"
          optionLabel="name"
          optionDisabled="disabled"
          [placeholder]="'label.InspectionItems' | translate"
          formControlName="items"
          class="w-full"
          appendTo="body"
        />
        @if (form.value.itemType === 'psa') {
          <p-button
            [label]="'inspection.selectOverduePsas' | translate"
            severity="info"
            [outlined]="true"
            icon="fa fa-clock"
            (click)="selectOverduePsas()"
          />
        }
      </div>
    </div>

    <div class="flex justify-end gap-2">
      <p-button
        [label]="'label.cancel' | translate"
        severity="secondary"
        (click)="closePopup()"
      />
      <p-button [label]="'label.save' | translate" type="submit" />
    </div>
  </form>
</p-dialog>
